import { recursivePropsVerification } from "./parser"
import { LAYOUT_SCHEMA } from "../layout/schema"
import { PAGE_SCHEMA } from "../pages/schema"
import {
  COVER_SECTION,
  CONTENT_SECTION,
  MENU_SECTION,
  NUMBERS_SECTION,
  SPEAKERS_SECTION,
  CAMPAIGN_SECTION,
  GALLERY_SECTION,
  FOOTER_SECTION,
  CONTACT_SECTION,
  TICKETS_SECTION,
  PERSONALIZED_FAQ_SECTION,
  LOGOS_SECTION,
  SPONSORS_SECTION,
  SCHEDULE_SECTION,
  TESTIMONIALS_SECTION,
  MATERIALS_SECTION
} from '../sections'

/* Sections able to parse data */
const SECTIONS = () => {
  const cover = COVER_SECTION()
  const content = CONTENT_SECTION()
  const menu = MENU_SECTION()
  const numbers = NUMBERS_SECTION()
  const speakers = SPEAKERS_SECTION()
  const campaign = CAMPAIGN_SECTION()
  const gallery = GALLERY_SECTION()
  const footer = FOOTER_SECTION()
  const contact = CONTACT_SECTION()
  const tickets = TICKETS_SECTION()
  const personalizedFaq = PERSONALIZED_FAQ_SECTION()
  const logos = LOGOS_SECTION()
  const sponsors = SPONSORS_SECTION()
  const schedule = SCHEDULE_SECTION()
  const testimonials = TESTIMONIALS_SECTION()
  const materials = MATERIALS_SECTION()

  return {
    [menu.schema.type]: menu,
    [cover.schema.type]: cover,
    [content.schema.type]: content,
    [numbers.schema.type]: numbers,
    [speakers.schema.type]: speakers,
    [campaign.schema.type]: campaign,
    [gallery.schema.type]: gallery,
    [footer.schema.type]: footer,
    [contact.schema.type]: contact,
    [tickets.schema.type]: tickets,
    [personalizedFaq.schema.type]: personalizedFaq,
    [logos.schema.type]: logos,
    [sponsors.schema.type]: sponsors,
    [schedule.schema.type]: schedule,
    [testimonials.schema.type]: testimonials,
    [materials.schema.type]: materials
  }
}

/* Methods */
export const parseObject = ({ schema, target }, beforeParse) => {
  if (beforeParse) beforeParse(target)
  recursivePropsVerification({ schema: schema, target: target })
  return target
}

export const parseSectionArray = arrayOfSections => {
  let arrayToParse = JSON.parse(JSON.stringify(arrayOfSections))

  for (let sectionToAnalyze of arrayToParse) {
    const predefinedTypeSCHEMA = SECTIONS()[sectionToAnalyze.type]

    if (predefinedTypeSCHEMA) {
      parseObject({ schema: predefinedTypeSCHEMA.schema, target: sectionToAnalyze }, predefinedTypeSCHEMA.beforeParse)
    }
  }

  return arrayToParse
}

export const parseLayoutArray = arrayOfLayout => {
  let arrayToParse = JSON.parse(JSON.stringify(arrayOfLayout))

  for (let layoutToAnalyze of arrayToParse) {

    if (layoutToAnalyze.id !== 'default-style') {
      parseObject({ schema: LAYOUT_SCHEMA({}), target: layoutToAnalyze })
    }
  }

  return arrayToParse
}

export const parsePagesArray = arrayOfPages => {
  let arrayToParse = JSON.parse(JSON.stringify(arrayOfPages))

  for (let pageToAnalyze of arrayToParse) {
    parseObject({ schema: PAGE_SCHEMA({}), target: pageToAnalyze })
  }

  return arrayToParse
}

export const createUsingSchema = schema => {
  return parseObject({ schema: schema, target: {} })
}